import { render } from "./Namespace.vue?vue&type=template&id=1fdf7be0&scoped=true"
import script from "./Namespace.vue?vue&type=script&lang=js"
export * from "./Namespace.vue?vue&type=script&lang=js"

import "./Namespace.vue?vue&type=style&index=0&id=1fdf7be0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdf7be0"]])

export default __exports__